interface JsonLdProps {
  data: Record<string, unknown>;
}

// Renders Schema.org structured data as an inline JSON-LD script in the body.
// This is intentionally separate from any head/meta tag handling.
export default function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}